/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Drive_Item_UnavailableInputs */

const fr_api_drive_item_unavailable = /** @type {(inputs: Api_Drive_Item_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet élément Drive est inaccessible. Sélectionnez-le avec le compte connecté à BusinessFlow.`)
};

const en_api_drive_item_unavailable = /** @type {(inputs: Api_Drive_Item_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Drive item is inaccessible. Select it with the account connected to BusinessFlow.`)
};

/**
* | output |
* | --- |
* | "This Drive item is inaccessible. Select it with the account connected to BusinessFlow." |
*
* @param {Api_Drive_Item_UnavailableInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_drive_item_unavailable = /** @type {((inputs?: Api_Drive_Item_UnavailableInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Drive_Item_UnavailableInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_drive_item_unavailable(inputs)
	return fr_api_drive_item_unavailable(inputs)
});